module.exports = __webpack_public_path__ + "img/logoblanco.eea06765.png";